var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"filled":"","rules":[_vm.durationFormat],"type":"text"},on:{"input":_vm.change},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}},'v-text-field',_vm.commonProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }